import { useEffect, useRef } from 'react';
import { getToken, subscribeToMessages } from '../services/fcmService';
import { saveFCMToken, deleteFCMToken } from '../services/userService';
import { notification } from 'antd';
import { axiosInstanceWithToken } from 'services/axiosInstance';

export const useFCM = (userId: string | null) => {
  const lastUserId = useRef<string | null>(null); // ✅ track previous userId

  useEffect(() => {
    let unsubscribe: () => void;

    const init = async () => {
      if (!userId || lastUserId.current === userId) return; // prevent duplicate init
      lastUserId.current = userId;
      const token = await getToken();
      if (token) {
        try {
          await saveFCMToken(token);
        } catch (err) {
          console.error('Error sending FCM token:', err);
        }
      }

      unsubscribe = subscribeToMessages((title, body) => {
        console.log('📩 FCM Received:', title, body);
        notification.success({
          message: title,
          description: body,
          placement: 'topRight', // ⬅️ Show from the right
          duration: 5, // seconds
        });
      });
    };

    init();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [userId]);
};

// export const deleteTokenFCM = async () => {
//   try {
//     const token = await getToken();
//     if (token) {
//       await deleteFCMToken(token);
//     }
//   } catch (error) {
//     console.error('Error deleting FCM token:', error);
//   }
// };

export const deleteTokenFCM = async (accessToken: string) => {
  try {
    const token = await getToken();
    if (token) {
      await axiosInstanceWithToken.post(
        "/users/delete-fcm-token",
        { token },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
    }
    console.log("FCM token deleted successfully");
  } catch (err) {
    console.error("Failed to delete FCM token", err);
  }
};
